module.exports = __webpack_public_path__ + "img/logo-tz.05bfacf6.png";